import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  return (
    <footer className="border-t bg-muted/30 py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="flex items-center gap-2">
            <Logo className="h-12 w-12" />
            <span className="font-semibold">LoopBaan.ai</span>
          </div>
          <div className="flex gap-6 text-sm text-muted-foreground">
            <Link to="/contact" className="hover:text-foreground">Contact</Link>
            <Link to="/ats-optimization" className="hover:text-foreground">ATS Guide</Link>
            <a 
              href="https://app.termly.io/document/terms-of-service/your-policy-id" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              Terms
            </a>
            <a 
              href="https://app.termly.io/document/privacy-policy/your-policy-id" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              Privacy
            </a>
            <a 
              href="https://app.termly.io/document/cookie-policy/your-policy-id" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              Cookies
            </a>
          </div>
        </div>
        <div className="mt-8 text-center text-sm text-muted-foreground">
          © 2025 LoopBaan.ai. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
